<ng-container *ngIf="paymentMode">
  <div data-cy="mb-checkout-billing-payment-card"
       (click)="onPaymentModeSelected(paymentMode)"
       [ngClass]="['row no-gutters px-3 py-3 mt-3 mb-4 mb-checkout-billing-payment-card',
                    isSelectedPayment ? 'selected' : '',
                    paymentMode.poPaymentMode ? 'mb-invoice-height': '']"
  >
    <div class="col-12">
      <input type="radio"
             [id]="paymentMode?.code"
             name="paymentModeCard"
             [checked]="isSelectedPayment"
             data-cy="mb-payment-card-input"/>
      <label class="mb-payment-card-title mb-custom-label" [for]="paymentMode?.code">
        {{paymentMode?.name}}
      </label>
    </div>
    <ng-container *ngIf="!paymentMode?.poPaymentMode">
      <div class="col-12">
        <img *ngIf="isForUS$ | async"
             src="../../../../../../assets/icons/payment_icons/amex_icon.svg"
             class="mr-2 mb-2"
             width="50"
             title="AMEX"
             alt="AMEX"
             aria-label="AMEX"
             data-cy="amex-icon"/>
    
        <img *ngIf="(isForUS$ | async) || (isForAU$ | async)"
             src="../../../../../../assets/icons/payment_icons/visa_icon.svg"
             class="mr-2 mb-2"
             width="50"
             title="VISA"
             alt="VISA"
             aria-label="VISA"
             data-cy="visa-icon"/>
    
        <img *ngIf="(isForUS$ | async) || (isForAU$ | async)"
             src="../../../../../../assets/icons/payment_icons/mastercard_icon.svg"
             class="mr-2 mb-2"
             width="50"
             title="MASTERCARD"
             alt="MASTERCARD"
             aria-label="MASTERCARD"
             data-cy="mastercard-icon"/>
      </div>
      <div class="col-12 mb-payment-card-description">
        <b>{{paymentMode?.description}}</b>
      </div>
    </ng-container>
  </div>
</ng-container>
